import { InvoiceIntegrationModel } from "../InvoiceIntegrationModel";
export function fromDTO(dto, isZeroAmount) {
  return {
    id: dto.id,
    clientContactId: dto.clientContactId,
    items: dto.items,
    formattedNumber: dto.formattedNumber,
    integration: dto.integration ? InvoiceIntegrationModel.fromDTO(dto.integration, isZeroAmount) : null
  };
}